import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import Home from './Pages/Home';
import NewCase from './Pages/NewCase';
import Consulta from './Pages/Consulta';
import Login from './Pages/Login';
import store  from './Redux/store';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist'
import CodeTracking from './Pages/CodeTracking';
import Activate from './Pages/Activate';

import { useCookies } from 'react-cookie';
import { CustomProvider } from 'rsuite';
import * as locales from 'rsuite/locales';

let persistor = persistStore(store)

const data = Object.keys(locales).map(key => ({
  key,
  value: locales[key]
}));

function App() {
  const [cookies, setCookie] = useCookies(['languaje']);
  let lan = (cookies.languaje == null) ? "ES" : cookies.languaje;

  let local = (lan == "ES") ? "esES" : "enGB";
  const locale = data.find(item => item.key === local); 

  return (
    <Provider store={store}>
        <CustomProvider locale={locale.value}>
          <PersistGate loading={null} persistor={persistor}>
            <Router>
              <Routes>
                <Route exact path="/" element={<Home/>}/>
                <Route exact path="/registration" element={<NewCase/>}/>
                <Route exact path="/code-tracking" element={<CodeTracking/>}/>
                <Route exact path="/consulta" element={<Consulta/>}/>
                <Route exact path="/login" element={<Login/>}/>
                <Route exact path="/activate" element={<Activate/>}/>
              </Routes>
            </Router>
          </PersistGate>
        </CustomProvider>
    </Provider>
  );
}

export default App;
